<template>
  <PopupTemplate @close="close()">
    <button
      v-if="!this.telEnviado"
      class="closeMenuButton"
      @click.prevent="close()"
    >
      <span>x</span>
    </button>

    <div v-if="!this.telEnviado" style="min-width: 30rem;">
      <p style="font-size:125%; font-weight: bold;">¡Te llamamos!</p>
      <p>
        Por favor, confirmanos el teléfono en el que quieres recibir la llamada:
      </p>
      <form class="pure-form pure-form-aligned">
        <input
          id="telefono"
          v-model.trim="telefono"
          type="tel"
          class="pure-input"
          placeholder="Nº Teléfono sin espacios"
          maxlength="10"
          required
          @keydown="errorTelefono = null"
        />

        <div v-if="errorTelefono" class="telNoValido">{{ errorTelefono }}</div>
        <button
          type="submit"
          class="pure-button boton"
          title="Pulse el botón para ponernos en contacto contigo"
          @click.prevent="enviarFormulario"
        >
          Ok
        </button>
      </form>
    </div>

    <div v-else-if="!errorGestionDuplicada" style="width:100%">
      <p>Gracias por solicitar información</p>
      <p>Con la máxima brevedad posible nos pondremos en contacto contigo.</p>
      <button
        type="submit"
        class="pure-button pure-button-primary"
        style="width:100%"
        @click.prevent="close()"
      >
        Ok
      </button>
    </div>

    <div v-else style="width:100%;">
      <p>Ya has solicitado nuestra llamada anteriormente.</p>
      <p>En breve nos pondremos en contacto contigo.</p>
      <button
        type="submit"
        class="pure-button pure-button-primary"
        style="width:100%"
        @click.prevent="close()"
      >
        Ok
      </button>
    </div>
  </PopupTemplate>
</template>

<script>
import actions from "@/util/actions.js";
export default {
  store: ["step"],
  data() {
    return {
      errorTelefono: null,
      errorGestionDuplicada: false,
      telefono: null,
      telEnviado: false
    };
  },

  mounted() {
    if (
      this.step.datosIdentificacion != null &&
      this.step.datosIdentificacion.telefono != null
    ) {
      this.telefono = this.step.datosIdentificacion.telefono;
    }
  },

  methods: {
    enviarFormulario: async function() {
      let expresionRegular = /^([9,7,6]{1})+([0-9]{8})$/;
      this.errorTelefono = "";

      if (this.telefono == null) {
        this.errorTelefono = "Escriba un número de teléfono";
        return;
      }

      if (this.telefono.length < 1) {
        this.errorTelefono = "Escriba un número de teléfono";
        return;
      }

      if (!expresionRegular.test(this.telefono)) {
        this.errorTelefono = "Número de telefono incorrecto";
        return;
      }

      let response = await actions.crearGestionTeLlamamosError(this.telefono);
      if (response.codigo == 0) {
        this.telEnviado = true;
      } else {
        if (response.codigo == 1009) {
          this.telEnviado = true;
          this.errorGestionDuplicada = true;
        } else {
          this.telEnviado = false;
        }
      }
    },

    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped>
.boton {
  background-color: $verdeMMT;
  border-radius: 5px;
  margin-top: 1rem;
  color: white;
  font-weight: bold;
  width: 100%;
}

input {
  width: 100%;
  min-width: 15rem;
}

.telNoValido {
  color: red;
  font-weight: bold;
}

.closeMenuButton {
  z-index: 9999;
  position: absolute;
  top: 0rem;
  right: 0.7rem;
  font-size: 140%;
  color: rgba(0, 0, 0, 0.8);
  border-radius: 0.75rem;
  background-color: white;
  font-weight: bold;
  padding: 0px;
  border: none;
}
</style>
